import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedUtilErrorHandlingModule } from '@mode/shared/util-error-handling';
import { LoadFeatureFlagsGuard } from './feature-flags.guard';

@NgModule({
  imports: [CommonModule, SharedUtilErrorHandlingModule],
  providers: [LoadFeatureFlagsGuard],
})
export class SharedUtilFeatureFlagsModule {}
